import React from "react";
import "./Reports.css";

function Reports() {
  return (
    <div className="finances-reports">
      <div className="finances-reports__placeholder">
        <div className="finances-reports__title">Раздел «Отчеты» в разработке</div>
        <div className="finances-reports__text">Здесь скоро появится функционал раздела</div>
      </div>
    </div>
  );
}

export default Reports;
